import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Signup from '../Components/Auth/signup';
import Login from '../Components/Auth/Login';
import AuthenticateProvider from '../Context/AuthenticateProvider';
import PublicRouters from './PublicRouter'
import PrivateRouters from './PrivateRouter';
import CreateProfile from '../Components/Profile';
import BusinessFeed from '../Components/User';
import CreatePostPage from '../Components/User/CreateIndex';
import Posts from '../Components/User/Posts'
import ViewIndex from '../Components/User/Posts/Viewindex';
import UpdateIndex from '../Components/User/Posts/UpdateIndex';

import Notification from '../Components/User/Notification';
import AdminChatPage from '../Components/Admin/ChatPage';

import Dashboard from '../Components/Admin/Dashboard';
import Logs from '../Components/Admin/Logs';
import AdminBusinessList from '../Components/Admin/List';
import AdminChatList from '../Components/Admin/ChatList'; 
import AdminAnnouncement from '../Components/Admin/Announcement';
import SetPassword from '../Components/Auth/Password';
import CreateCommunity from '../Components/User/Community/CreateCommunity';
import EditCommunity from '../Components/User/Community/EditCommunity';
import CommunityMembers from "../Components/User/Community/CommunityMembers";
import CommunityChat from "../Components/User/Community/CommunityChat";
import AdminCommunityList from "../Components/Admin/AdminCommunityList";
import MyCommunities from "../Components/User/Community/MyCommunities";
import EventList from '../Components/User/Events/EventList';
import ViewEvent from '../Components/User/Events/ViewEvent';
import CreateEvent from '../Components/User/Events/CreateEvent';
import LinkCommunity from '../Components/User/Events/LinkCommunity';
import InviteVendor from '../Components/User/Events/InviteVendor';
import MeetingList from '../Components/User/Meetings/Meetinglist';
import CreateMeeting from '../Components/User/Meetings/Createmeeting';
import EditMeeting from '../Components/User/Meetings/Editmeeting';
import MeetingCalendar from '../Components/User/Meetings/Meetingcalendar';

import DealList from '../Components/User/Mini_crm/DealList';
import CreateDeal from '../Components/User/Mini_crm/CreateDeal';
import RespondDeal from '../Components/User/Mini_crm/RespondDeal';
import CompleteDeal from '../Components/User/Mini_crm/CompleteDeal';
import DealChat from '../Components/User/Mini_crm/DealChat';
import AdminDealList from '../Components/Admin/Admindeallist';
import ReviewList from "../Components/User/Reviews/Reviewlist";
import TopVendors from '../Components/User/TopVendors/Topvendors';
import AdminTopVendors from '../Components/Admin/Admintopvendors';
import VerificationRequest from '../Components/User/Verified_Batch/VerificationRequest';
import AdminVerification from '../Components/Admin/Adminverification';
import AdminCommunityMembers from '../Components/Admin/AdminCommunityMembers';


import UserAdminChat from '../Components/User/Useradminchat';
import Chat from '../Components/Chat/Chat';
import ChatList from '../Components/Chat/Chatlist';


const index = () => {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Router>
          <Routes>
            <Route element={<PublicRouters />}>
              <Route path="/login" element={<Login />} />
               <Route path="/signup" element={<Signup />} />
              <Route path="/set-password/:token" element={<SetPassword />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Route>
            <Route element={<PrivateRouters allowedRoles={["admin"]} />}>
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/logs" element={<Logs />} />
              <Route path="/admin/list" element={<AdminBusinessList />} />
              <Route path="/admin/chat-list" element={<AdminChatList />} />
              <Route path="/admin/chat" element={<AdminChatPage />} />
              <Route path="/admin/announcement" element={<AdminAnnouncement />} />
              
              <Route path="/admin/communities" element={<AdminCommunityList />} />

              <Route path="/admin/deals" element={<AdminDealList />} />
              <Route path="/admin/top-vendors" element={<AdminTopVendors />} />
              <Route path="/admin/verification" element={<AdminVerification />} />
              <Route path="/admin/community-members" element={<AdminCommunityMembers />} />
              <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
            </Route>
            <Route element={<PrivateRouters allowedRoles={["business"]} />}>
              <Route path="/user/reg" element={<CreateProfile />} />
              <Route path="/user/feed" element={<BusinessFeed />} />
              <Route path="/user/create-post" element={<CreatePostPage />} />
              <Route path="/user/my-posts" element={<Posts />} />
              <Route path="/user/view-post/:id" element={<ViewIndex />} />
              <Route path="/user/edit-post/:id" element={<UpdateIndex />} />

              <Route path="/user/notifications" element={<Notification />} />
              {/* <Route path="/user/admin-chat" element={<ChatIndex />} /> */}
              <Route path="/user/admin-chat" element={<UserAdminChat />} />
              <Route path="*" element={<Navigate to="/user/feed" replace />} />

              {/* 🔥 COMMUNITY ROUTES */}
              <Route path="/user/create-community" element={<CreateCommunity />} />
              <Route path="/user/edit-community" element={<EditCommunity />} />
              <Route path="/user/community-members" element={<CommunityMembers />} />
              <Route path="/user/community-chat" element={<CommunityChat />} />
              <Route path="/user/communities" element={<MyCommunities />} />

              <Route path="/user/events" element={<EventList />} />
              <Route path="/user/create-event" element={<CreateEvent />} />
              <Route path="/user/event/:id" element={<ViewEvent />} />
              <Route path="/user/link-community/:id" element={<LinkCommunity />} />
              <Route path="/user/invite/:id" element={<InviteVendor />} />

              <Route path="/user/meetings" element={<MeetingList />} />
              <Route path="/user/create-meeting" element={<CreateMeeting />} />
              <Route path="/user/edit-meeting/:id" element={<EditMeeting />} />
              <Route path="/user/meeting-calendar" element={<MeetingCalendar />} />

              {/* Mini CRM routes */}
              <Route path="/user/crm" element={<DealList />} />
              <Route path="/user/crm/create" element={<CreateDeal />} />
              <Route path="/user/crm/respond/:id" element={<RespondDeal />} />
              <Route path="/user/crm/complete/:id" element={<CompleteDeal />} />
              <Route path="/user/crm/chat/:id" element={<DealChat />} />

              <Route path="/user/reviews" element={<ReviewList />} />

              <Route path="/user/top-vendors" element={<TopVendors />} />

              <Route path="/user/verification" element={<VerificationRequest />} />

              <Route path="/user/chat" element={<Chat />} />
              <Route path="/user/chat-list" element={<ChatList />} />
              
            
            </Route>
          </Routes>
        </Router>
      </AuthenticateProvider>
    </React.Fragment>
  )
}

export default index
